import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Optional } from '../../shared/shared.types';

@Injectable({
  providedIn: 'root',
})
export class MLoginPaymentDetailsService {
  private static readonly PAYMENT_KEY = 'MLoginPaymentDetails';
  private readonly storage: StorageService = inject(LOCAL_STORAGE);

  public get(): MLoginPaymentDetails {
    return this.storage.get(MLoginPaymentDetailsService.PAYMENT_KEY);
  }

  public set(paymentDetails: MLoginPaymentDetails) {
    this.storage.set(MLoginPaymentDetailsService.PAYMENT_KEY, paymentDetails);
  }

  public remove() {
    this.storage.remove(MLoginPaymentDetailsService.PAYMENT_KEY);
  }
}

export class MLoginPaymentDetails {
  type!: string;
  cardType?: Optional<string>;
  lastDigits?: Optional<string>;
}

export function isSepaMLoginPaymentType(
  paymentDetails: Optional<MLoginPaymentDetails>,
): boolean {
  return isMLoginPaymentType('sepa', paymentDetails);
}

export function isCreditCardMLoginPaymentType(
  paymentDetails: Optional<MLoginPaymentDetails>,
): boolean {
  return isMLoginPaymentType('credit_card', paymentDetails);
}

export function isAmericanExpressMLoginPaymentType(
  paymentDetails: Optional<MLoginPaymentDetails>,
): boolean {
  return isMLoginPaymentType('credit_card', paymentDetails) && paymentDetails?.cardType === 'amex';
}

function isMLoginPaymentType(
  name: string,
  paymentDetails: Optional<MLoginPaymentDetails>,
): boolean {
  return paymentDetails != null && paymentDetails.type === name;
}
